import { toAbsoluteUrl } from "../url";

type LanguageItem = {
  lang: string;
  name: string;
  flag: string;
  value: string;
  label: string;
};

export const languageList = (gettext: (key: string) => string) => {
  const languages = [
    createLanguageObject("da", gettext("Danish"), "174-denmark.svg"),
    createLanguageObject("de", gettext("German"), "162-germany.svg"),
    createLanguageObject("en", gettext("English"), "012-uk.svg"),
    createLanguageObject("nb", gettext("Norwegian"), "143-norway.svg"),
    createLanguageObject("sv", gettext("Swedish"), "184-sweden.svg"),
    createLanguageObject("nl", gettext("Dutch"), "237-netherlands.svg"),
    createLanguageObject("fr", gettext("French"), "195-france.svg"),
    createLanguageObject("es", gettext("Spanish"), "128-spain.svg"),
    // createLanguageObject("zh", gettext("Mandarin"), "015-china.svg"),
    // createLanguageObject("ja", gettext("Japanese"), "063-japan.svg"),
  ];

  return languages.sort((a, b) => a.lang.localeCompare(b.lang));
};

const createLanguageObject = (
  lang: string,
  name: string,
  flag: string,
): LanguageItem => ({
  lang,
  name,
  flag: toAbsoluteUrl(`/media/svg/flags/${flag}`),
  value: lang,
  label: name,
});
